import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'

export const processAssignmentService = {
    getProcessAssignments: async (user) => {
        return (await axios.get(`${NODE_BASE_URL}/admin/process-assignments`, getAxiosOptions(user))).data
    },
    createProcessAssignment: async (user, data) => {
        return (await axios.post(`${NODE_BASE_URL}/admin/process-assignments`, data, getAxiosOptions(user))).data
    },
    updateProcessAssignment: async (user, id, data) => {
        return (
            await axios.put(
                `${NODE_BASE_URL}/admin/process-assignments/${id}`,
                data,
                getAxiosOptions(user)
            )
        ).data
    },
    deleteProcessAssignment: async (user, id) => {
        return (
            await axios.delete(`${NODE_BASE_URL}/admin/process-assignments/${id}`, getAxiosOptions(user))
        ).data
    },
}
